import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { notificationActions as actions,  } from '../actions';
import { notificationService } from '../services';

/* Get Notification Sagas */
function* handleGetNotificationRequest() {
  const action = yield take(actions.getNotificationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(notificationService.getNotification, dataParams);
    if (res.isError) {
      yield put(actions.getNotificationError(res));
    
    } else {
      yield put(actions.getNotificationSuccess(res));
     
    }
  } catch (error) {
    yield put(actions.getNotificationError());
    
  }
}

/* Get All Designation Sagas */
function* handleDeleteNotificationRequest() {
  const action = yield take(actions.deleteNotificationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(notificationService.deleteNotification, dataParams);
    if (res.isError) {
      yield put(actions.deleteNotificationError(res));
    } else {
      yield put(actions.deleteNotificationSuccess(res));
    }

  } catch (error) {
    yield put(actions.deleteNotificationError());
  }
}

/* Get Designation By Department Sagas */
function* handleUpdateNotificationRequest() {
  const action = yield take(actions.updateNotificationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(notificationService.updateNotification, dataParams);
    if (res.isError) {
      yield put(actions.updateNotificationError(res));

    } else {
      yield put(actions.updateNotificationSuccess(res));
    }

  } catch (error) {
    yield put(actions.updateNotificationError());
  }
}

/* Get Designation By Department Sagas */
function* handleDeleteAllNotificationRequest() {
  const action = yield take(actions.deleteAllNotificationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(notificationService.deleteAllNotification, dataParams);
    if (res.isError) {
      yield put(actions.deleteAllNotificationError(res));

    } else {
      yield put(actions.deleteAllNotificationSuccess(res));
    }

  } catch (error) {
    yield put(actions.deleteAllNotificationError());
  }
}





/* -----------Watchers------------- */
function* handleGetNotificationWatcher() {
  yield takeEvery(
    actions.getNotificationRequest,
    handleGetNotificationRequest,
  );
}

function* handleDeleteNotificationWatcher() {
  yield takeEvery(
    actions.deleteNotificationRequest,
    handleDeleteNotificationRequest,
  );
}

function* handleUpdateNotificationWatcher() {
  yield takeEvery(
    actions.updateNotificationRequest,
    handleUpdateNotificationRequest,
  );
}

function* handleDeleteAllNotificationWatcher() {
  yield takeEvery(
    actions.deleteAllNotificationRequest,
    handleDeleteAllNotificationRequest,
  );
}

function* rootNotificationSaga() {
  yield all([
    handleGetNotificationRequest(),
    handleGetNotificationWatcher(),

    handleDeleteNotificationRequest(),
    handleDeleteNotificationWatcher(),

    handleUpdateNotificationRequest(),
    handleUpdateNotificationWatcher(),

    handleDeleteAllNotificationWatcher(),
    handleDeleteAllNotificationRequest(),

  ]);
}

export default rootNotificationSaga;
